import { useMemo } from "react";
import Chart from "react-apexcharts";
import { Card, CardContent, Typography, Box } from "@mui/material";

const PALETA = ['#1976d2','#ed6c02','#2e7d32','#9c27b0','#d32f2f','#0288d1','#7b1fa2','#388e3c'];

export const GraficoPorUsuario = ({ data }) => {
  const topUsuarios = useMemo(() => {
    const map = {};
    (data || []).forEach((r) => {
      const u = r.id_usuarios || 'N/A';
      map[u] = (map[u] || 0) + (parseInt(r.cantidad, 10) || 0);
    });
    return Object.entries(map)
      .map(([u, total]) => ({ usuario: `U-${u}`, total }))
      .sort((a, b) => b.total - a.total)
      .slice(0, 8);
  }, [data]);

  if (topUsuarios.length === 0) return null;

  const colores = topUsuarios.map((_, i) => PALETA[i % PALETA.length]);

  const chartOptions = {
    chart: {
      type: 'bar',
      toolbar: { show: false },
      animations: { enabled: true, speed: 600 },
      fontFamily: 'Roboto, sans-serif',
    },
    plotOptions: {
      bar: {
        horizontal: true,
        borderRadius: 5,
        distributed: true,
        dataLabels: { position: 'right' },
        barHeight: '60%',
      },
    },
    colors: colores,
    xaxis: {
      categories: topUsuarios.map(u => u.usuario),
      labels: { style: { fontSize: '12px', colors: '#666' } },
      axisBorder: { show: false },
      axisTicks: { show: false },
    },
    yaxis: {
      labels: { style: { fontSize: '12px', colors: '#444', fontWeight: 600 } },
    },
    legend: { show: false },
    dataLabels: {
      enabled: true,
      offsetX: 6,
      style: { fontSize: '12px', fontWeight: 600, colors: ['#444'] },
      formatter: (v) => v.toLocaleString('es-AR'),
    },
    tooltip: {
      y: { formatter: (v) => `${v.toLocaleString('es-AR')} usos` },
      theme: 'light',
    },
    grid: {
      borderColor: '#f0f0f0',
      strokeDashArray: 4,
      yaxis: { lines: { show: false } },
    },
    fill: { type: 'solid', opacity: 0.9 },
  };

  const series = [{ name: 'Usos', data: topUsuarios.map(u => u.total) }];
  const chartHeight = Math.max(220, topUsuarios.length * 44 + 60);

  return (
    <Card elevation={2} sx={{ borderRadius: 3, height: '100%' }}>
      <CardContent>
        <Typography variant="h6" fontWeight={700} mb={0.5}>Consumo por usuario</Typography>
        <Typography variant="body2" color="text.secondary" mb={1}>
          Top {topUsuarios.length} usuarios con mayor actividad
        </Typography>
        <Box>
          <Chart options={chartOptions} series={series} type="bar" height={chartHeight} />
        </Box>
      </CardContent>
    </Card>
  );
};
